<template>
  <start-layer clip-waves-class="white text-body-1" :offset=".9">

    <h3 class="mb-3 text-left">Start</h3>
    <v-list class="my-0 px-0 transparent li-grid" dense>
      <v-list-item
        v-for="[ to, title, icon ] in ACTIONS" :key="title"
        class="li-pop ec-dark-blue--text"
        exact :to="to"
      >
        <v-icon small v-html="icon" />
        <div v-html="title" />
        <v-icon small v-html="mdiChevronRight" />
      </v-list-item>
    </v-list>

    <h3 class="mb-3 text-left">Products / features</h3>
    <v-list class="my-0 px-0 transparent li-grid" dense>
      <v-list-item
        v-for="header in SECTIONS" :key="header.name"
        class="li-pop ec-dark-blue--text"
        exact
        :to="{ name: getRouteName(header.name) }"
      >
        <v-icon small v-html="header.icon" />
        <div>{{header.nameLong || header.name}}</div>
        <v-icon small v-html="mdiChevronRight" />
      </v-list-item>
    </v-list>

    <h3 class="mb-3 text-left">More information</h3>
    <v-list class="mt-0 mb-16 px-0 transparent li-grid" dense>
      <v-list-item
        v-for="[ to, title, icon ] in [
          [ { name: 'pricing' }, 'Pricing', mdiCurrencyUsd ],
          [ { name: 'faq' }, 'FAQ', mdiFrequentlyAskedQuestions ],
          [ { name: 'blog' }, 'Blog', mdiFormatFloatLeft ]
        ]"
        :key="title"
        class="li-pop ec-dark-blue--text"
        exact
        :to="to"
      >
        <v-icon small v-html="icon" />
        <div class="flex-grow-1">{{title}}</div>
        <v-icon small v-html="mdiChevronRight" />
      </v-list-item>
    </v-list>

  </start-layer>
</template>


<style scoped>
.li-grid {
  display: grid;
  grid-template-columns: 1fr;
  font-size: unset;
}

.li-grid > * {
  transition: box-shadow .5s;
  overflow: hidden;
}

@media (min-width: 600px) {
  .li-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 960px) {
  .li-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 4px;
  }
  .li-grid > * {
    border-radius: 8px;
  }
}
</style>


<script>
import ClipWaves from '@/components/ClipWaves.vue';
import StartLayer from '@/components/StartLayer.vue';
import { ACTIONS } from '@/utils/start-actions.js';
import { SECTIONS, getRouteName } from '@/utils/start-sections.js';
import { mdiChevronRight, mdiCurrencyUsd, mdiFrequentlyAskedQuestions, mdiFormatFloatLeft, mdiEmail, mdiHome } from '@mdi/js';

export default {
  name: 'start-footer',
  components: { ClipWaves, StartLayer },
  created() {
    Object.assign(this, { ACTIONS, SECTIONS, getRouteName, mdiChevronRight, mdiCurrencyUsd, mdiFrequentlyAskedQuestions, mdiFormatFloatLeft, mdiEmail, mdiHome });
  }
}
</script>
